import { FC, memo } from "react";
import { StyledChatNoScreen } from "./index.styled";
import NoUserScreen from "./NoUserScreen";
import { useParams } from "react-router-dom";
import ErrorUserScreen from "./ErrorUserScreen";

const ChatContent: FC = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const { chatId } = useParams();

  if (!chatId) {
    return (
      <StyledChatNoScreen>
        <NoUserScreen />
      </StyledChatNoScreen>
    );
  }

  // if (isLoading) {
  //   return (
  //     <StyledChatContentScreen>
  //       <AppLoader />
  //     </StyledChatContentScreen>
  //   );
  // }

  // if (activeChat) {
  //   return (
  //     <StyledChatContentScreen>
  //       <MessagesScreen
  //         activeChat={chat}
  //         agents={agents}
  //         selectedAgentToFiler={selectedAgentToFiler}
  //       />
  //     </StyledChatContentScreen>
  //   );
  // }

  return (
    <StyledChatNoScreen>
      <ErrorUserScreen />
    </StyledChatNoScreen>
  );
};
export default memo(ChatContent);
